import { gql } from '@apollo/client';

export default gql`
  mutation setVonageCallRecordingStatus($agentEmail: String!, $status: String!) {
    setVonageCallRecordingStatus(agentEmail: $agentEmail, status: $status)
  }
`;
